import React, { useEffect } from 'react'
import Services from '../Components/Services'

const Servicespage = () => {
    useEffect(() => {
        window.scrollTo(0, 0); // Scrolls to top when component loads
      }, []);
  return (
    <div className='py-20'>
      <Services/>
    </div>
  )
}

export default Servicespage
